module.exports = __webpack_public_path__ + "media/images/bg/shapes/gallery/trips-08f64f4c047aa118a924bf1266a26c98.svg";